document.addEventListener('DOMContentLoaded', function() {
  if (!customElements.get("banner-scroll")) {
    customElements.define(
      "banner-scroll",
      class BannerScroll extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.getAttribute('data-sectionId');
          this._swiper = null;

          this.initBannerScroll();
          this.initBannerResize();
        }

        connectedCallback() {
          // 组件挂载后可以做一些初始化
        }

        disconnectedCallback() {
          // 在组件移除时清理事件
          window.removeEventListener('resize', this.resizeHandler);
          if (this._swiper) {
            this._swiper.destroy();
          }
        }

        initBannerResize() {
          this.resizeHandler = () => {
            // 使用 requestAnimationFrame 来节流 resize 处理函数
            cancelAnimationFrame(this.resizeTimeout);
            this.resizeTimeout = requestAnimationFrame(() => {
              this.initBannerScroll();
            });
          };

          window.addEventListener('resize', this.resizeHandler);
        }

        initBannerScroll() {
          let cWidth = window.innerWidth;
          if (cWidth >= 750) {
            if (!this._swiper || this._swiper.destroyed) {
              this._swiper = new Swiper(`.swiper-${this.sectionId}`, {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 16,
                autoplay: {
                  disableOnInteraction: false,
                },  
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
              });
            }
          } else {
            if (this._swiper && !this._swiper.destroyed) {
              this._swiper.destroy();
              this._swiper = null; // 清理 swiper 实例
            }
          }
        }
      }
    );
  }
});
